export default {"src":"/_next/static/image/public/images/ic_evening.875fd6684682c125777f755de5e36e95.svg","height":18,"width":18};